/* @flow */

import * as React from 'react';

type Props = {
  activeProp?: string,
  children: React.Node,
  component: React.ComponentType<*>,
  value: any,
};

const defaultProps = {
  activeProp: 'selected',
};

function MenuWrapper({
  activeProp,
  children,
  component: Component,
  value,
  ...restProps
}: Props) {
  const selectedIndex = React.Children.toArray(children).findIndex(ch => ch && ch.props.id === value);

  return (
    <Component selectedIndex={selectedIndex} {...restProps}>
      {React.Children.map(children, child => (
        React.isValidElement(child) ? React.cloneElement(child, {
          [activeProp]: child.props.id === value,
        }) : null
      ))}
    </Component>
  );
}

MenuWrapper.defaultProps = defaultProps;

export default MenuWrapper;
